import React from 'react';
import { Spinner } from './Spinner';


interface PageSpinnerProps {
  'data-testid'?: string;
}

/**
 * PageSpinner - Centered loading spinner for full page loading states
 * 
 * @description
 * Wrapper component that centers a large spinner with appropriate padding.
 * Used by PageLayout and other containers to show loading state.
 * 
 * @example
 * <PageLayout>
 *   {isLoading ? <PageSpinner data-testid="page-loading" /> : <Content />}
 * </PageLayout>
 */
export const PageSpinner: React.FC<PageSpinnerProps> = ({
  'data-testid': dataTestId = 'page-spinner',
}) => (
  <div
    className="flex items-center justify-center p-8"
    data-testid={dataTestId}
  >
    <Spinner size="lg" />
  </div>
);

export default PageSpinner;
